import { Directive, ElementRef, inject, input } from '@angular/core';

@Directive({
  selector: '[appClickArea]',
  exportAs: 'appClickArea',
  host: {
    '(click)': 'onClick($event.target)'
  }
})
export class AppClickAreaDirective {
  private elRef = inject(ElementRef);

  readonly disabledClickArea = input(false);

  onClick(target: HTMLElement) {
    if (target.tagName !== 'INPUT' && !this.disabledClickArea()) {
      const nativeElement = this.elRef.nativeElement as HTMLElement;
      const checkbox: HTMLElement = nativeElement.querySelector(
        'input[type=checkbox], input[type=radio]'
      );
      if (checkbox) checkbox.click();
    }
  }
}
